<div class="w-100 container">
  <mat-sidenav-container class="w-100"
                         autosize>
    <mat-sidenav mode="side"
                 [class.left-side-nav]="isCollapsed">
      <mat-tree #tree
                [dataSource]="dataSource"
                [childrenAccessor]="childrenAccessor">
        <mat-tree-node *matTreeNodeDef="let node;when: hasChild"
                       matTreeNodePadding
                       [class.hidden]="!node.root && isCollapsed"
                       [class.active]="isActiveLink(node)"
                       [cdkTreeNodeTypeaheadLabel]="node.name">
          <div class="node-content w-100">
            <div aria-hidden="true" class="expanded-node"
                 [class.hidden]="isCollapsed"
                 matTreeNodeToggle
                 (click)="select(node)">
              <div class="title" >
                @if (node.icon) {
                  <mat-icon>{{ node.icon }}</mat-icon>
                }
                <div class="link">{{ node.label }}
                </div>
              </div>
              @if (node.children) {
                <mat-icon class="mat-icon-rtl-mirror">
                  {{ tree.isExpanded(node) ? 'chevron-up' : 'chevron-down' }}
                </mat-icon>
              }
            </div>
            @if (node.root && isCollapsed) {
              <div aria-hidden="true" (click)="navigate(node)"
                   class="collapsed-node">
                <mat-icon>{{ node.icon }}</mat-icon>
              </div>
            }
          </div>
        </mat-tree-node>
      </mat-tree>
    </mat-sidenav>
    <mat-sidenav-content [class.right-side-nav]="isCollapsed">
      <ng-content></ng-content>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
